module.exports = __webpack_public_path__ + "media/jksp.3ef6b76b.mp4";